"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _commonSetLocation = _interopRequireDefault(require("./common-set-location"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CLASS_NAME_VISIBLE = 'common-set-location__visible';
var CLASS_NAME_HIDDEN = 'common-set-location__hidden';
var toggleVisibilityClassName = function toggleVisibilityClassName(visible) {
  if (visible === void 0) {
    visible = true;
  }
  if (typeof document !== 'undefined') {
    setTimeout(function () {
      if (visible) {
        document.body.classList.add(CLASS_NAME_VISIBLE);
        document.body.classList.remove(CLASS_NAME_HIDDEN);
      } else {
        document.body.classList.remove(CLASS_NAME_VISIBLE);
        document.body.classList.add(CLASS_NAME_HIDDEN);
      }
    });
  }
};
var CommonSetLocationWrapper = function CommonSetLocationWrapper(props) {
  var disappearAfterLocationSet = props.disappearAfterLocationSet;
  var disappearClassAdded = (0, _react.useRef)(false);
  var cachedLocation = (0, _utils.getCachedLocation)();
  if (disappearAfterLocationSet && Boolean(cachedLocation.stateCode)) {
    if (!disappearClassAdded.current) {
      toggleVisibilityClassName(false);
      disappearClassAdded.current = true;
    }
    return null;
  }
  toggleVisibilityClassName(true);
  return /*#__PURE__*/_react["default"].createElement(_commonSetLocation["default"], (0, _extends2["default"])({
    onUnmount: function onUnmount() {
      return toggleVisibilityClassName(false);
    }
  }, props));
};
CommonSetLocationWrapper.resourceType = function () {
  return 'LocationSelector_1_0_0';
};
CommonSetLocationWrapper.defaultProps = {
  disappearAfterLocationSet: true
};
var _default = CommonSetLocationWrapper;
exports["default"] = _default;